import type { AlertEvent } from "./alert-model.js";
import type { EarconSeverity } from "../../audio/earcon.js";
import type { Settings } from "../../platform/store.js";
import { inQuietHours } from "../../platform/quiet-hours.js";

/** Map a routed alert event to the earcon tier it should sound. */
export function earconSeverityFor(ev: AlertEvent): EarconSeverity {
  if (ev.kind === "allClear") return "clear";
  if (ev.severity === "critical") return "critical";
  if (ev.severity === "warning") return "warning";
  return "info";
}

/** Whether a surfaced alert should make any sound right now. */
export function shouldChime(settings: Settings, now: Date): boolean {
  return settings.alertSoundEnabled === true && !inQuietHours(settings.quietHours, now);
}
